export { default as App } from "./App/App";
export { default as Layout } from "./Layout/Layout";
export {
  default as AuthenticatedLayout
} from "./Pages/Auth/Layout/AuthenticatedLayout";
export { default as PagePermission } from "./Permissions/PagePermission";

export { default as HomePage } from "./Pages/Dashboard/HomePage";
export { default as Page404Page } from "./Pages/Page404/Page404";
export { default as ProfilePage } from "./Pages/Auth/Profile/ProfilePage";

export { default as LoginPage } from "./Pages/Auth/Login/LoginPage";
export {
  default as DistributorPage
} from "./Pages/Auth/Distributor/DistributorPage";
export {
  default as LostPasswordPage
} from "./Pages/Auth/PasswordRecovery/LostPasswordPage";
export {
  default as PasswordActivatePage
} from "./Pages/Auth/PasswordRecovery/PasswordActivatePage";
export { default as RegisterPage } from "./Pages/Auth/Register/RegisterPage";
export {
  default as EmailChangePage
} from "./Pages/Auth/EmailChange/EmailChangePage";

export { default as UsersListPage } from "./Pages/Users/UsersList";
export { default as EditUserPage } from "./Pages/Users/EditUser";
export { default as ArticlesListPage } from "./Pages/Articles/ArticlesList";
export { default as EditArticlePage } from "./Pages/Articles/EditArticle";
export {
  default as DistributorsListPage
} from "./Pages/Distributors/DistributorsList";
export {
  default as EditDistributorPage
} from "./Pages/Distributors/EditDistributor";
export {
  default as BannedCashregistersListPage
} from "./Pages/Cashregisters/BannedCashregisters/BannedCashregistersList";
export {
  default as EditBannedCashregistersPage
} from "./Pages/Cashregisters/BannedCashregisters/EditBannedCashregisters";
export {
  default as ReregisterPage
} from "./Pages/Cashregisters/Reregister/ReregList";
export {
  default as EventTypesListPage
} from "./Pages/Cashregisters/EventTypes/EventTypesList";
export {
  default as EditEventTypePage
} from "./Pages/Cashregisters/EventTypes/EditEventType";
export {
  default as StickersListPage
} from "./Pages/Cashregisters/Stickers/StickersList";
export {
  default as AnnualReviewsListPage
} from "./Pages/Cashregisters/AnnualReviews/AnnualReviewsList";
export {
  default as EditAnnualReviewPage
} from "./Pages/Cashregisters/AnnualReviews/EditAnnualReview";
export {
  default as CrulesListPage
} from "./Pages/Cashregisters/Crules/CrulesList";

export {
  default as CashregistersListPage
} from "./Pages/Cashregisters/Cashregisters/CashregistersList";
export {
  default as EditCashregisterPage
} from "./Pages/Cashregisters/Cashregisters/EditCashregister";
export {
  default as EditRightPage
} from "./Pages/Cashregisters/Cashregisters/EditRight";

export {
  default as AeeRegsListPage
} from "./Pages/Cashregisters/AeeRegs/AeeRegsList";
export { default as DownloadsListtPage } from "./Pages/Downloads/DownloadsList";
export { default as EditDownloadPage } from "./Pages/Downloads/EditDownload";
export {
  default as IncomingSmsListPage
} from "./Pages/Sms/IncomingSms/IncomingSmsList";
export {
  default as OutgoingSmsListPage
} from "./Pages/Sms/OutgoingSms/OutgoingSmsList";
export {
  default as SmsListItemsListPage
} from "./Pages/Sms/SmsListItems/SmsListItemsList";
export {
  default as EditSmsListItemPage
} from "./Pages/Sms/SmsListItems/EditSmsListItem";
export { default as ExamsListPage } from "./Pages/Exams/Exams/ExamsList";
export { default as EditExamPage } from "./Pages/Exams/Exams/EditExam";
export {
  default as ExamineeExamsPage
} from "./Pages/Exams/ExamineeExams/ExamineeExamsList";
export {
  default as EditExamineeExamPage
} from "./Pages/Exams/ExamineeExams/EditExamineeExam";
export { default as MyExamsListPage } from "./Pages/MyExams/MyExamsList";
export { default as EditMyExamPage } from "./Pages/MyExams/EditMyExam";
export {
  default as NotificationsListPage
} from "./Pages/Notifications/NotificationsList";

export {
  default as ServiceOrdersListPage
} from "./Pages/ServiceOrders/ServiceOrdersList";
export {
  default as EditServiceOrderPage
} from "./Pages/ServiceOrders/EditServiceOrder";
export { default as ClientsListPage } from "./Pages/Clients/ClientsList";
export { default as EditClientPage } from "./Pages/Clients/EditClient";
export {
  default as WorksheetsListPage
} from "./Pages/Worksheets/Worksheets/WorksheetsList";
export {
  default as EditWorksheetPage
} from "./Pages/Worksheets/Worksheets/EditWorksheet";
export {
  default as WorkfeesListPage
} from "./Pages/Worksheets/Workfees/WorkfeesList";
export {
  default as EditWorkfeePage
} from "./Pages/Worksheets/Workfees/EditWorkfee";

export { default as EventsListPage } from "./Pages/Events/EventsList";

export { default as SigningPage } from "./Pages/Signing/Signing";
export {
  default as ChangesList
} from "./Pages/Cashregisters/Changes/ChangesList";
export {
  default as EditChange
} from "./Pages/Cashregisters/Changes/EditChange";
export {
  default as SmodeListPage
} from "./Pages/Cashregisters/Smode/AeeRegsList";
export {
  default as CWorksheetsListPage
} from "./Pages/Cashregisters/Worksheets/WorksheetsList";



// WEBPACK FOOTER //
// ./src/Containers/index.js